// Promise.allSettled polyfill
// TODO: To be removed once SC-8866 is done

export const promiseStatus = {
  fulfilled: 'fulfilled',
  rejected: 'rejected',
};

export function reflect(promise) {
  return promise
    .then((value) => ({ status: promiseStatus.fulfilled, value }))
    .catch((reason) => ({ status: promiseStatus.rejected, reason }));
}
